import * as ToggleGroup from '@radix-ui/react-toggle-group';

import { AppIcons, type AppIconName } from '@web/ui/core/atoms/icons';
import { twcn } from '@web/ui/core/utils';

const PROJECT_ICONS: readonly AppIconName[] = [
  'headset',
  'chats',
  'chat-dots',
  'lifebuoy',
  'airplane',
  'bed',
  'car',
  'globe',
  'crown',
  'star',
  'briefcase',
  'building-office',
  'currency',
  'receipt',
  'credit-card',
  'bank',
  'warning-octagon',
  'shield-warning',
  'flag',
  'target',
  'users',
  'user',
  'rocket',
  'package',
  'settings',
  'lightning',
  'sparkle',
  'compass',
];

type Props = {
  value: AppIconName;
  onChange: (next: AppIconName) => void;
  options?: readonly AppIconName[];
  iconSize?: number;
  ariaLabel?: string;
};

export function IconSelectorGroup({
  value,
  onChange,
  options = PROJECT_ICONS,
  iconSize = 18,
  ariaLabel,
}: Readonly<Props>): React.JSX.Element {
  return (
    <ToggleGroup.Root
      type="single"
      value={value}
      onValueChange={(next) => {
        // Radix emits "" when the active item is clicked. Treat as no-op to
        // preserve the previous single-select semantics ("required").
        if (next) onChange(next as AppIconName);
      }}
      aria-label={ariaLabel}
      className="grid grid-cols-icon-selector gap-1.5"
    >
      {options.map((name) => (
        <ToggleGroup.Item
          key={name}
          value={name}
          title={name}
          aria-label={name}
          className={twcn(
            'flex aspect-square items-center justify-center rounded-sm border border-transparent bg-transparent text-muted-foreground',
            'transition-colors duration-fast ease-standard',
            'hover:bg-muted hover:text-foreground',
            'data-[state=on]:bg-primary-tint data-[state=on]:text-primary data-[state=on]:border-primary',
          )}
        >
          <AppIcons name={name} size={iconSize} />
        </ToggleGroup.Item>
      ))}
    </ToggleGroup.Root>
  );
}
